import moment from 'moment'

export const data = () => ({
  isDebug: true,
  loading: false,
  showFilters: false,
  toggle: false,
  suggestions: [],
  formatDateFn: function(value) {
    return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
  },

  filters: {
    show: false
  },

  region: {},

  rows: [],

  columns: [
    {
      field: 'suggestion',
      label: 'Suggestion',
      aria: 'Suggestion',
      width: '60%',
      sortable: true,
      searchable: true
    },
    {
      field: 'createdBy',
      label: 'Created By',
      aria: 'Created By',
      width: '15%',
      sortable: true,
      searchable: true
    },
    {
      field: 'createdDate',
      label: 'Created',
      date: true,
      width: '10%',
      sortable: true,
      searchable: true
    }
  ],

  styles: {
    dateSelector: {
      display: 'flex',
      padding: '12px',
      textAlign: 'center',
      verticalAlign: 'middle',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'flex-end'
    },
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
